import { apiClient, type TruckModelExEntity } from '@/libs/api'

export type FetchTruckModelQuery = {
  tenantKey: string
  truckModelId: number
}

/**
 * 車種単一を取得
 */
export const fetchTruckModel = async (
  { tenantKey, truckModelId }: FetchTruckModelQuery,
  signal?: AbortSignal
): Promise<TruckModelExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .truck_models._id(truckModelId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
